import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-details',
  templateUrl: './exam-details.component.html',
  styleUrls: ['./exam-details.component.scss']
})
export class ExamDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
